<template>
    <w-dialog
        :model-value="show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-light1--bg white"
    >
        <w-form @success="tambahPelarasan()">
            <w-flex class="pa6" column :gap="3">
                <w-input
                    type="number"
                    v-model="cukai.tahun"
                    label="Tahun"
                    :validators="[validators.required]"
                    disabled
                >
                </w-input>
                <!-- <z-lookup
                    :label="'Kod Hasil'"
                    :url="apiBaseUrl + `/akaunCukai?hmAkaunId=${hm.id}`"
                    :sort="false"
                    :cache="false"
                    v-model="cukai.akaun_id"
                    :validators="[validators.required]"
                /> -->
                <w-select
                  :items="akaunCukai"
                  v-model="cukai.akaun_id"
                  label="Kod Hasil"
                  :validators="[validators.required]"
                >
                </w-select>
                <w-input v-model="cukai.amaun_debit" type="number">
                    Amaun Debit (RM)<span class="caption ml3"
                        >Contoh: Cukai Tanah / Cukai Parit & Tali Air</span
                    >
                </w-input>
                <w-input v-model="cukai.amaun_kredit" type="number">
                    Amaun Kredit (RM)
                    <span class="caption ml3">Contoh: Diskaun</span>
                </w-input>
                <w-input v-model="cukai.tunggakan_dari" type="text">
                    Ulasan
                    <!-- <span class="caption ml3">Contoh: Diskaun</span> -->
                </w-input>
                <w-input v-model="cukai.tunggakan_hingga" type="text">
                    Fail Rujukan
                    <!-- <span class="caption ml3">Contoh: Diskaun</span> -->
                </w-input>
            </w-flex>
            <w-flex class="px6" v-if="$zutil.can('Kemaskini Hakmilik')">
                <div class="spacer" />
                <w-button
                    :loading="loading"
                    @click="
                        $emit('close');
                        cukai = {};
                    "
                    text
                >
                    Batal
                </w-button>
                <w-button :loading="loading" class="ml3" type="submit"> Simpan </w-button>
            </w-flex>
        </w-form>

        <w-alert error outline v-if="error">{{ error }}</w-alert>
    </w-dialog>
</template>

<script setup>
import { ref, watch } from "vue";
import WaveUI from "wave-ui";
import moment from "moment";
import { usePage } from '@inertiajs/inertia-vue3';

const waveui = new WaveUI();
const emit = defineEmits(["close", "onSuccess"]);
const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    hm: {
        type: Object,
        default: {
            no_hm: "020101GM00000022",
        },
    },
    cukaiToEdit: {
        type: Object,
    },
});
const valid = ref(null)
const validators = ref({
    required: (value) => !!value || "Sila Isi Ruangan Ini",
});
const apiBaseUrl = process.env.MIX_API_BASE_URL;
const loading = ref(false);
const user_id = usePage().props.value.auth.user.id;

const dialog = ref({
    fullscreen: false,
    persistent: true,
    persistentNoAnimation: false,
    width: "50%",
});

const cukai = ref({
    id: props.cukaiToEdit.id ?? null,
    amaun_debit: props.cukaiToEdit.amaun_debit ?? null,
    amaun_kredit: props.cukaiToEdit.amaun_kredit ?? null,
    no_hm: props.hm.no_hm,
    akaun_id: props.cukaiToEdit.akaun_id ?? null,
    tahun: props.cukaiToEdit.tahun ?? moment().year(),
    user_id:user_id,
});

watch(
    () => props.hm,
    (nv, ov) => {
        cukai.value.no_hm = nv.no_hm;
    }
);
const akaunCukai= [{ label: "Loading", selected: true }];
const error = ref(null);

async function tambahPelarasan() {
    console.log(hm);
    loading.value = true;
    // await axios({
    //     method: "post",
    //     url: `${apiBaseUrl}/senaraiHmCukai?hmAkaunId=${hmAkaunId=hm.id}`,
    //     responseType: "json",
    //     data: cukai.value,
    // })
    //     .then((e) => {
    //         waveui.notify({
    //             success: true,
    //             message: `Berjaya! Maklumat cukai telah ${
    //                 isTambah ? "ditambah" : "dikemaskini"
    //             }.`,
    //             timeout: 3000,
    //         });
    //         emit("onSuccess", e.data);
    //     })
    //     .catch((e) => {
    //         waveui.notify({
    //             error: true,
    //             message: e.response.data.message,
    //             timeout: 3000,
    //         });
    //         error.value = e.response.data.message;
    //     })
    //     .finally((e) => {
    //         loading.value = false;
    //     });
}


</script>
